import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { useTranslation } from "react-i18next"
import { useMeasure } from "react-use"
import { twMerge } from "tailwind-merge"
import { bikeLabelStep } from "features/bikeLabelOrder/constants"
import { useGetStepQueryParams } from "features/bikeLabelOrder/hooks/useGetStepQueryParams"
import { useAppSelector } from "store/hooks"

const BikeLabelOrderVisualStep: React.FC = () => {
	const { t } = useTranslation()
	const [ref, { width }] = useMeasure<HTMLDivElement>()
	const validateStep = useAppSelector((state) => state.bikeLabelOrder.validatedLabelOrderStep)

	const step = useGetStepQueryParams()
	const gap = width > 900 ? "gap-40" : "justify-between"

	return (
		<div ref={ref} className={clsx("flex w-full text-xs", gap, { "flex-col": isMobileOnly })}>
			{Object.entries(bikeLabelStep).map(([key, { index, label }]) => {
				const isCurrentStep = step === index
				return (
					<div key={`visual-${index}`} className="flex items-center gap-4">
						<div
							className={twMerge(
								"rounded-full primary-color items-center justify-center leading-3 flex w-6 h-6",
								isCurrentStep
									? "bg-primary text-white"
									: index <= validateStep
										? "text-primary font-semibold bg-transparent"
										: "bg-transparent text-gray-700 font-semibold"
							)}
						>
							{index}
						</div>
						<div
							className={twMerge(
								"capitalize leading-3",
								index <= validateStep || isCurrentStep
									? "text-primary"
									: "text-gray-600",
								isCurrentStep && "font-semibold"
							)}
						>
							{t(label, { ns: "label" })}
						</div>
					</div>
				)
			})}
		</div>
	)
}
export default BikeLabelOrderVisualStep
